export const triggerCustomGaEvent = (eventName, eventBody) => {
  let gaEvent = new CustomEvent(eventName, { detail: eventBody })

  dispatchEvent(gaEvent)
}

// Note: Taken from BAY202-8
export function decorateUrlWithGAParam(urlString) {
  var ga = window[window['GoogleAnalyticsObject']]
  var tracker
  if (ga && typeof ga.getAll === 'function') {
    tracker = ga.getAll()[0] // Uses the first tracker created on the page
    urlString = new window.gaplugins.Linker(tracker).decorate(urlString)
  }
  return urlString
}

export const pushToDataLayer = data => {
  try {
    const dataLayer = window?.dataLayer || []
    dataLayer.push(data)
  } catch (err) {
    //   do nothing
    if (process.env.NODE_ENV !== 'production') {
      console.warn(err)
    }
  }
}
